import { unitSelector } from './unitSelector.js';

// jsPDF no soporta el símbolo μ, se reemplaza por "micro "
export const unitSelectorPDF = (parameterType) =>
    unitSelector(parameterType).replaceAll('μ', 'micro ');

export default unitSelectorPDF;
